import Vue from 'vue'
import Vuex from 'vuex'
import Const from "../helpers/Const";
import ConstTerms from '../helpers/ConstTerms';
import {fetchFilters} from '../api/index.js';
import alert from './store_alert';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alert,
  },

  actions: {
    FETCH_FILTERS({commit}) {
      return fetchFilters().then( response => {
        commit('setFilters', response.data.filters)
        commit('setEnv', response.data.env)
      });
    },
  },

  getters: {
    getSubsc: (state) => ({
      pkg: state.pkg,
      subsc: state.subsc,
      subscRecommendedAdvisor: state.subscRecommendedAdvisor,
      user: state.user,
      vehicle: state.vehicle,
      att: state.att,
      term: state.term,
      user_scp: state.user_scp,
    }),
  },



  mutations: {
    setAtt(state, {morph, col, path}) {
      switch (morph) {
        case Const.MORPH.SUBSC:
          state.att.subsc.card.path = path;
          break;
        case Const.MORPH.VEHICLE:
          var att = state.att.vehicle[col];
          att.path = path;
          state.att.vehicle = att;
          break;
      }
    },

    setBtnLoading(state, boolean){
      state.btnLoading = boolean;
    },

    setFilters(state, filters) {
      state.filters = filters;
    },

    setEnv(state, { pis, tell, tell2, email, host_plus, host_prime, host_s3, ip, host_vtg }) {
      state.envServer.ip = (typeof ip != 'undefined') ? ip : state.envServer.ip;
      state.envServer.pis = (typeof pis != 'undefined') ? pis : state.envServer.pis;
      state.envServer.email = (typeof email != 'undefined') ? email : state.envServer.email;
      state.envServer.tell = (typeof tell != 'undefined') ? tell : state.envServer.tell;
      state.envServer.tell2 = (typeof tell2 != 'undefined') ? tell2 : state.envServer.tell2;

      state.host.plus = (typeof host_plus != 'undefined') ? host_plus : state.host.host_plus;
      state.host.prime = (typeof host_prime != 'undefined') ? host_prime : state.host.host_prime;
      state.host.vtg = (typeof host_vtg != 'undefined') ? host_vtg : state.host.host_vtg;
      state.host.s3 = (typeof host_s3 != 'undefined') ? host_s3 : state.host.host_s3;
    },

    setIsApp(state, isApp){
      state.isApp = isApp;
    },

    setItems(state, {pkgs, prods, vehicle_cats}) {
      state.pkgs = pkgs;
      state.prods = prods;
      state.vehicleCats = vehicle_cats;
    },

    setPayment(state, {date, num, price_pkg, price_payment, card_type, promo, promo_code, terms, step}) {
      //state.subsc.payments.card = card; //DELETE ME
      state.subsc.payments.date = date;
      state.subsc.payments.num = num;
      state.subsc.payments.terms = terms;
      state.subsc.payments.price_pkg = price_pkg;
      state.subsc.payments.price_payment = price_payment;
      state.subsc.payments.card_type = card_type;
      state.subsc.payments.promo = promo;
      state.subsc.payments.promo_code = promo_code;
      state.subsc.payments.step = step;
    },

    setPkg(state, {id, is_assurance, price_pkg, title, vehicle_cat_id,}) {
      state.pkg.id = (typeof id !== "undefined") ? id : state.pkg.id;
      state.pkg.title = (typeof title !== "undefined") ? title : state.pkg.title;
      state.pkg.is_assurance = (typeof is_assurance !== "undefined") ? is_assurance : state.pkg.is_assurance;
      state.vehicle.vehicle_cat_id = (typeof vehicle_cat_id !== "undefined") ? vehicle_cat_id : state.vehicle.vehicle_cat_id;
      state.subsc.payments.price_pkg = (typeof price_pkg !== "undefined") ? price_pkg : state.subsc.payments.price_pkg;
    },

    // setTerm(state, {
    //   masking, masking_chk,

    //   service_agreement, personal_info_agree, marketing, ad_receive_agree,

    //   ad_receive_email, ad_receive_sms, ad_receive_app,

    //   insurance_survey,
    //   insurance, insurance_personal_info_agree, insurance_marketing,
    // }) {
    //   state.term[ConstTerms.MASKING] = (typeof masking !== "undefined") ? masking : state.term[ConstTerms.MASKING];
    //   state.term[ConstTerms.MASKING_CHK] = (typeof masking_chk !== "undefined") ? masking_chk : state.term[ConstTerms.MASKING_CHK];

    //   state.term[ConstTerms.SERVICE_AGREEMENT] = (typeof service_agreement !== "undefined") ? service_agreement : state.term[ConstTerms.SERVICE_AGREEMENT];
    //   state.term[ConstTerms.PERSONAL_INFO_AGREE] = (typeof personal_info_agree !== "undefined") ? personal_info_agree : state.term[ConstTerms.PERSONAL_INFO_AGREE];
    //   state.term[ConstTerms.MARKETING] = (typeof marketing !== "undefined") ? marketing : state.term[ConstTerms.MARKETING];
    //   state.term[ConstTerms.AD_RECEIVE_AGREE] = (typeof ad_receive_agree !== "undefined") ? ad_receive_agree : state.term[ConstTerms.AD_RECEIVE_AGREE];

    //   state.term[ConstTerms.AD_RECEIVE_EMAIL] = (typeof ad_receive_email !== "undefined") ? ad_receive_email : state.term[ConstTerms.AD_RECEIVE_EMAIL];
    //   state.term[ConstTerms.AD_RECEIVE_SMS] = (typeof ad_receive_sms !== "undefined") ? ad_receive_sms : state.term[ConstTerms.AD_RECEIVE_SMS];
    //   state.term[ConstTerms.AD_RECEIVE_APP] = (typeof ad_receive_app !== "undefined") ? ad_receive_app : state.term[ConstTerms.AD_RECEIVE_APP];

    //   state.term[ConstTerms.INSURANCE_SERVEY] = (typeof insurance_survey !== "undefined") ? insurance_survey : state.term[ConstTerms.INSURANCE_SERVEY];

    //   state.term[ConstTerms.INSURANCE] = (typeof insurance !== "undefined") ? insurance : state.term[ConstTerms.INSURANCE];
    //   state.term[ConstTerms.INSURANCE_PERSONAL_INFO_AGREE] = (typeof insurance_personal_info_agree !== "undefined") ? insurance_personal_info_agree : state.term[ConstTerms.INSURANCE_PERSONAL_INFO_AGREE];
    //   state.term[ConstTerms.INSURANCE_MARKETING] = (typeof insurance_marketing !== "undefined") ? insurance_marketing : state.term[ConstTerms.INSURANCE_MARKETING];
    // },

    setTerm(state, terms) {
      for (let type in terms)
        if(typeof state.term[type] !== "undefined")
          state.term[type] = terms[type];
    },

    setUser(state, {id, email, name, vtg_id, vtg_no, mobile, vehicles, connInfo}) {
      state.user.id = (typeof id !== "undefined") ? id : state.user.id;
      state.user.email = (typeof email !== "undefined") ? email : state.user.email;
      state.user.name = (typeof name !== "undefined") ? name : state.user.name;
      state.user.vtg_id = (typeof vtg_id !== "undefined") ? vtg_id : state.user.vtg_id;
      state.user.vtg_no = (typeof vtg_no !== "undefined") ? vtg_no : state.user.vtg_no;
      state.user.mobile = (typeof mobile !== "undefined") ? mobile : state.user.mobile;
      state.user.vehicles = (typeof vehicles !== "undefined") ? vehicles : state.user.vehicles;
      state.user.connInfo = (typeof connInfo !== "undefined") ? connInfo : state.user.connInfo;
    },

    setUserScp(state, {id, email, name, vtg_id, vtg_no, mobile, vehicles, ci}) {
      state.user_scp.id = (typeof id !== "undefined") ? id : state.user_scp.id;
      state.user_scp.email = (typeof email !== "undefined") ? email : state.user_scp.email;
      state.user_scp.name = (typeof name !== "undefined") ? name : state.user_scp.name;
      state.user_scp.vtg_id = (typeof vtg_id !== "undefined") ? vtg_id : state.user_scp.vtg_id;
      state.user_scp.vtg_no = (typeof vtg_no !== "undefined") ? vtg_no : state.user_scp.vtg_no;
      state.user_scp.mobile = (typeof mobile !== "undefined") ? mobile : state.user_scp.mobile;
      state.user_scp.vehicles = (typeof vehicles !== "undefined") ? vehicles : state.user_scp.vehicles;
      state.user_scp.ci = (typeof ci !== "undefined") ? ci : state.user_scp.ci;
    },

    setSubsc(state, { pkg, subsc, user, vehicle, att, term }){
      state.pkg = (typeof pkg != 'undefined') ? pkg : state.pkg;
      state.subsc = (typeof subsc != 'undefined') ? subsc : state.subsc;
      state.user = (typeof user != 'undefined') ? user : state.user;
      state.vehicle = (typeof vehicle != 'undefined') ? vehicle : state.vehicle;
      state.att = (typeof att != 'undefined') ? att : state.att;
      state.term = (typeof term != 'undefined') ? term : state.term;
    },

    setSubscDaelerCdkId(state, dealer_cdk_id){
      state.subsc.dealer_cdk_id = dealer_cdk_id;
    },

    setOcrData(state, { owner_name, date_reg, num_reg, model_slug, model_type, model_year, num_id }){
      state.ocrData.data.owner_name = owner_name;
      state.ocrData.data.reg_date = date_reg;
      state.ocrData.data.car_reg_no = num_reg;
      state.ocrData.data.model.model_slug = model_slug;
      state.ocrData.data.model.model = model_type;
      state.ocrData.data.model.model_year = model_year;
      state.ocrData.data.car_vin = num_id;
    },

    getVehicle(state){
      return state.vehicle
    },

    setVehicle(state, { date_reg_cdk, num_reg_cdk, date_reg, num_reg, model_type, model_year, num_id, month_diff_index, vehicle_cat_title, vehicle_cat_detail, vehicle_cat_detail_desc}) {
      //사용자 이름은 oas 사용자 이름을 사용한다.
      // user_name,model_slug,
      // state.user.name = (typeof user_name !== "undefined") ? user_name : state.user.name;
      state.vehicle.date_reg_cdk = (typeof date_reg_cdk !== "undefined") ? date_reg_cdk : state.vehicle.date_reg_cdk;
      state.vehicle.num_reg_cdk = (typeof num_reg_cdk !== "undefined") ? num_reg_cdk : state.vehicle.num_reg_cdk;


      state.vehicle.date_reg = (typeof date_reg !== "undefined") ? date_reg : state.vehicle.date_reg;
      state.vehicle.model.type = (typeof model_type !== "undefined") ? model_type : state.vehicle.model.type;
      state.vehicle.model.year = (typeof model_year !== "undefined") ? model_year : state.vehicle.model.year;
      state.vehicle.num_id = (typeof num_id !== "undefined") ? num_id : state.vehicle.num_id;
      state.vehicle.num_reg = (typeof num_reg !== "undefined") ? num_reg : state.vehicle.num_reg;

      state.vehicle.vehicle_cat_title = (typeof vehicle_cat_title !== "undefined") ? vehicle_cat_title : state.vehicle.vehicle_cat_title;
      state.vehicle.vehicle_cat_detail = (typeof vehicle_cat_detail !== "undefined") ? vehicle_cat_detail : state.vehicle.vehicle_cat_detail;
      state.vehicle.vehicle_cat_detail_desc = (typeof vehicle_cat_detail_desc !== "undefined") ? vehicle_cat_detail_desc : state.vehicle.vehicle_cat_detail_desc;
      state.vehicle.month_diff_index = (typeof month_diff_index !== "undefined") ? month_diff_index : state.vehicle.month_diff_index;
      // 임시저장. 이후 vehicle로 통일 고려   20.03.12  sang
      //20.08.19 jeon 보여주기 데이터 사용 X oas return data 사용


      // 나중에 위치 옮기기... 차량데이터로 이동
      // state.ocrData.data.month_diff_index = month_diff_index;
    },
    setVehiclePanel(state, {km}) {
      state.vehicle.km = (typeof km !== "undefined") ? km : state.vehicle.km;
    },
    // 구독 완료시 저장되어있던 데이터 초기화
    unsetSubsc(state) {

      state.pkg = { title: '', id: 0, },

          state.subsc = {
            dealer_cdk_id: 0,
            state_req: 0,
            date_start: '',
            parent_subsc_id: 0,
            payments: {
              date: '', num: '', price_pkg: 0, price_promo_cal : 0, price_promo_code : 0, price_payment: 0, price_promo: 0,
              //card: { name: '', num: '', expire_month: '', expire_year: '', cvc: '', pw: '', }, //DELETE ME
              terms: {
                [ConstTerms.PAY_PERSONAL] : false,
                [ConstTerms.PAY_ELECTRONIC_FIN] : false,
                [ConstTerms.PAY_PERSONAL_INFO] : false,
                [ConstTerms.PAY_THIRD_PARTY_PROVIDE] : false,
              },
            }
          },

          state.vehicle =  {
            date_reg_cdk: '',
            date_reg: '',
            num_id: '',
            num_reg: '',
            vehicle_cat_id: 0,
            km: '',
            month_diff_index: 0,    // 임시? 아니면 어디에 저장? 그냥 따로 저장? 고려
            model: { type: '', year: '', },
          },

          state.att = {
            subsc: { card: { attachable_type: Const.MORPH.SUBSC, path: '', }, },
            vehicle: {
              insp: { attachable_type: Const.MORPH.VEHICLE, path: '', },
              num_reg: { attachable_type: Const.MORPH.VEHICLE, path: '', },
              panel: { attachable_type: Const.MORPH.VEHICLE, path: '', },
            },
          },

          this.commit('unsetTerms');

      state.ocrData = {
        user_id: '', handleKey: '', url: '',
        file_name: '',              // 없어질 paramater
        need_modify_data: true,    // 기본 값
        data: {
          car_vin: '', car_reg_no: '', reg_date: '',
          model: { model: '', model_year: '', model_slug: ''}, owner_name: '',
        }
      }
    },

    unsetMasking(state){
      state.term[ConstTerms.MASKING] = false;
      state.term[ConstTerms.MASKING_CHK] = false;
    },

    unsetTerm(state) {
      state.term[ConstTerms.SERVICE_AGREEMENT] = false;
      state.term[ConstTerms.PERSONAL_INFO_AGREE] = false;
      state.term[ConstTerms.MARKETING] = false;
      state.term[ConstTerms.AD_RECEIVE_AGREE] = false;
    },

    unsetTermRecevie(state) {
      state.term[ConstTerms.AD_RECEIVE_EMAIL] = false;
      state.term[ConstTerms.AD_RECEIVE_SMS] = false;
      state.term[ConstTerms.AD_RECEIVE_APP] = false;
    },

    unsetTermInsurance(state) {
      state.term[ConstTerms.INSURANCE_SERVEY] = false;

      state.term[ConstTerms.INSURANCE] = false;
      state.term[ConstTerms.INSURANCE_PERSONAL_INFO_AGREE] = false;
      state.term[ConstTerms.INSURANCE_MARKETING] = false;
    },

    unsetTerms() {
      this.commit('unsetMasking');
      this.commit('unsetTerm');
      this.commit('unsetTermRecevie');
      this.commit('unsetTermInsurance');
    },

    setPopup401(state, boolean) {
      state.popup401 = boolean;
    },

    openPopup(state, {name, isConfirm, onOpened, onClosed}) {
      history.pushState(null, '', document.location.href);
      state.openedPopup[name] = {
        opened: true,
        isConfirm: isConfirm,
        onOpened: onOpened,
        onClosed: onClosed,
      }

      document.body.style.overflowY = 'auto';
      for (let k in state.openedPopup){
        if (state.openedPopup[k] && state.openedPopup[k].opened){
          document.body.style.overflowY = 'hidden';
        }
      }

      if (onOpened) onOpened();
    },

    closePopup(state, {name}) {
      let popup = state.openedPopup[name];

      if (popup && popup.onClosed) popup.onClosed();
      delete state.openedPopup[name]

      document.body.style.overflowY = 'auto';
      for (let k in state.openedPopup){
        if (state.openedPopup[k] && state.openedPopup[k].opened){
          document.body.style.overflowY = 'hidden';
        }
      }
    },
  },

  state: {
    profile: process.env.VUE_PROFILE || 'prod',
    dir: process.env.BASE_URL,
    bmwPlusHome: process.env.VUE_APP_BMW_PLUS_HOME,
    vantageHom: process.env.VUE_APP_VANTAGE_HOME,

    /*
     *  OAS parameter
     */
    plus_id: null,       // 아이디(이메일)
    vtg_id: null,       // 아이디(이메일)
    preUrl: null,        // 이전화면

    //estimateForm
    selOpt: null,        // 선택 상품     ex) 4,7,9
    campaignNo: null,    // 캠페인 idx
    brdCampaignNo: null, // 캠페인 화면 number
    vehicleIdx: null,    // 차량 idx
    scpNo: null,         // SCP 패키지 idx
    brdScpNo: null,      // SCP 패키지 idx

    openedPopup: {},

    filters:{},
    envServer:{
      ip:'',
      pis:true,
      email: '',
      tell: '010-0000-0000',
      tell2: '010-0000-0000',
    },
    host: {
      plus: '',
      prime: '',
      vtg: '',
      s3: '',
    },
    att: {
      subsc: {
        card: {
          attachable_type: Const.MORPH.SUBSC,
          path: '',
        },
      },
      vehicle: {
        insp: {
          attachable_type: Const.MORPH.SUBSC,
          path: '',
        },
        num_reg: {
          attachable_type: Const.MORPH.SUBSC,
          path: '',
        },
        panel: {
          attachable_type: Const.MORPH.SUBSC,
          path: '',
        },
      },
    },
    btnLoading:false,
    isApp: false,
    isDev: process.env.VUE_PROFILE !== 'production',
    isLocal: process.env.VUE_PROFILE === 'local',
    ocrData: {
      user_id: '',
      handleKey: '',
      url: '',
      file_name: '',              // 없어질 paramater
      need_modify_data: true,    // 기본 값
      data: {
        car_vin: '',
        car_reg_no: '',
        reg_date: '',
        model: {
          model: '',
          model_slug: '',
          model_year: ''
        },
        owner_name: '',
      }
    },
    pkg: {
      id: 0,
      is_assurance: false,
      title: '',
    },
    pkgs: {}, //패키지 목록; 항목 구성: id, is_assurance, pkg, title,
    prods: {}, //상품 목록; 항목 구성: content, icon, id, on, title, unit, unit_type,
    vehicleCats: {}, //차량분류 목록; 항목 구성: costs, id, title,
    subsc: {
      dealer_cdk_id: 0, // 결제시 딜러사 선택
      dealer_advisor_cdk_id: 0, // 가입시 추천 서비스 어드바이저 선택
      date_start: '',   // 연장신청의 경우 시작 날짜를 기준으로 구독 기간이 표시되어야 하므로, 연장신청 구독의 종료일 다음날이 시작일
      parent_subsc_id: 0,  // 연장신청의 경우 기존 구독 id
      payments: {
        //card: { name: '', num: '', expire_month: '', expire_year: '', cvc: '', pw: '', }, //DELETE ME
        date: '', //결제일
        num: '', //결제(주문)번호
        price_pkg: 0,         // 결제당시 패키지 금액(소비자가)
        price_payment: 0,     // 실제결제금액
        card_type: 10, //결제카드종류
        promo:{ //신규 or 연장
          rate:0, //할인율 or 금액
          price:0, // 할인금액
        },
        promo_code:{ //코드할인
          rate:0, //할인율 or 금액
          overlap:0, //중복여부
          slug:'', //할인코드
          price:0, //할인금액
        },
        terms: {
          [ConstTerms.PAY_PERSONAL] : false,
          [ConstTerms.PAY_ELECTRONIC_FIN] : false,
          [ConstTerms.PAY_PERSONAL_INFO] : false,
          [ConstTerms.PAY_THIRD_PARTY_PROVIDE] : false,
        },
        step: 0,
      },
      state_req: 0,     // 구독 신청 type. 기본값 0 , 연장신청 시 30
    },
    subscRecommendedAdvisor: {
      subsc_id: null,
      user_id: null,
    },
    term: {
      [ConstTerms.MASKING] : false,
      [ConstTerms.MASKING_CHK] : false,

      [ConstTerms.SERVICE_AGREEMENT] : false,
      [ConstTerms.PERSONAL_INFO_AGREE] : false,
      [ConstTerms.MARKETING] : false,
      [ConstTerms.AD_RECEIVE_AGREE] : false,

      [ConstTerms.AD_RECEIVE_EMAIL] : false,
      [ConstTerms.AD_RECEIVE_SMS] : false,
      [ConstTerms.AD_RECEIVE_APP] : false,

      [ConstTerms.INSURANCE_SERVEY] : false,

      [ConstTerms.INSURANCE] : false,
      [ConstTerms.INSURANCE_PERSONAL_INFO_AGREE] : false,
      [ConstTerms.INSURANCE_MARKETING] : false,
    },
    user: {
      id:0,
      email: '',
      name: '',
      vtg_id: '',
      vtg_no: '',
      mobile: '',
      vehicles: [],
      connInfo: '',
    },
    user_scp: {
      id:0,
      email: '',
      name: '',
      vtg_id: '',
      vtg_no: '',
      mobile: '',
      ci:'',
      vehicles: [],
    },
    vehicle: {
      date_reg_cdk: '',
      num_reg_cdk: '',

      date_reg: '',
      km: '',
      model: {
        type: '',
        year: '',
      },
      num_id: '',
      num_reg: '',
      vehicle_cat_id: 0,
      month_diff_index: 0,    // 임시? 아니면 어디에 저장? 그냥 따로 저장? 고려
      vehicle_cat_title: '',
      vehicle_cat_detail: '',
      vehicle_cat_detail_desc: '',
    },

    popup401 : false,
    insuranceName: 'Power Train Warranty',
    insuranceApplyNoti: `<span class="fw400 colorRed">Power Train Warranty 가입시에는</span> 실시간으로
 촬영된 차량 계기판 사진을 필요로 하오니 자동차 
 등록증, 자동차 정기검사 결과표를 모두 지참하시어 
 <span class="fw400 colorRed">차량 내에서</span> 가입을 진행해 주세요.`,
    msg_:`BMW Korea(주)는 통신판매중개자이며, 통신판매의 당사자가 아닙니다. 상품, 상품정보, 거래에 관한 의무와 책임은 판매자에게 있습니다.`,
  },
});

